<template>
  <div class="p-4" :class="{'p-6': !routeMeta.back}">
    <div class="text-2xl" v-if="routeMeta.back">
      <wd-button transparent @input="goTo('/')">
        <icon name="Back" />
      </wd-button>
    </div>
    <div class="text-center text-primary-500 mt-4 mb-6">
      <icon name="WaldigLogo" size="3.5em" :settings="{strokeWidth: 1, circle: true}" />
    </div>
    <div class="h-full max-w-lg mx-auto pt-0">
      <div class="ml-1">
        <h1 class="text-center">Was ist STUPSI?</h1>
        <p
          class="mb-4"
        >Bleib mit STUPSI aktiv für deine Gesundheit! In der STUPSI App findest du eine Liste an Aktivitäten, die deiner Gesundheit gut tun - Spazieren gehen, im Garten arbeiten, mit Freund*innen treffen und vieles mehr. Du kannst auch eigene neue Aktivitäten in der App erstellen.</p>
        <info-section level="2" title="Das kannst du mit den Aktivitäten machen">
          <ul class="list-disc list-outside ml-4 stack">
            <li>Hake eine Aktivität ab, wenn du sie gemacht hast (einmal pro Tag möglich).</li>
            <li>Setze dir Ziele zu deinen Aktivitäten und lege fest, wie oft du eine Aktivität in einem bestimmten Zeitraum machen möchtest - alleine oder gemein mit deinen STUPSI Freund*innen.</li>
            <li>Jede Aktivität ist einer von drei Kategorien zugeordnet - Körperliche Gesundheit, Geistige Gesundheit und Soziale Teilhabe. Schaffst du es, an jedem Tag Aktivitäten von allen drei Kategorien auszuführen?</li>
          </ul>
        </info-section>
        <info-section
          level="2"
          title="Wie kann ich Freund*innen hinzufügen?"
        >STUPSI ist kein Soziales Netzwerk wie Facebook und auch kein Nachrichten-Dienst wie WhatsApp. Um eine Freundin oder einen Freund in STUPSI hinzuzufügen, musst du den genauen Benutzernamen kennen. Danach könnt ihr euch gemeinsame Ziele rund um die Aktivitäten setzen. Miteinander reden, sich zu den Aktivitäten austauschen, gemeinsam lachen - all das passiert im besten Fall persönlich am Telefon oder beim nächsten Treffen.</info-section>
        <info-section level="2" title="Los geht’s mit der STUPSI App">
          <ol class="list-decimal ml-4">
            <li>
              Bitte rufe die App am Smartphone unter folgendem Link auf:
              <a
                target="_blank"
                href="http://stupsi.at"
              >http://stupsi.at</a>
            </li>
            <li>Registriere dich und erstelle dir ein STUPSI Profil.</li>
            <li>Melde dich mit deinen Login-Daten ein.</li>
            <li>Viel Freude mit STUPSI!</li>
          </ol>
        </info-section>
        <info-section level="2" title="Sicherheit">
          <div class="stack">
            <p>STUPSI speichert so wenig personenbezogene Daten wie möglich und du kannst die App auch ohne E-Mail Adresse oder Angabe deines vollen Namens nutzen.</p>
            <p>Achtung: Wenn du dein Passwort vergisst, kannst du dieses ohne Angabe einer E-Mail Adresse nicht mehr neu erstellen.</p>
            <p>Aus Sicherheitsgründen wird dein Account nach 6 Monaten gelöscht, wenn du dich in der Zeit nicht in STUPSI einloggst.</p>
          </div>
        </info-section>
      </div>
      <info-section title="Über das Projekt">
        <div class="stack">
          <p>Das Waldviertler Kernland ist eine Kleinregion, die aus 14 Gemeinden besteht. Von den rund 14.000 EinwohnerInnen sind mehr als 3.800 über 60 Jahre (= 27%, lt. Statistik Austria 2017). Kleine Ortschaften, Dörfer und Streusiedlungen prägen die Region, die vor allem von der Landwirtschaft, dem Gesundheitstourismus, Handwerk und einigen innovativen Betrieben lebt.</p>
          <p>Das Projekt „Digital, gesund altern“ ist ein Versuch, älteren Menschen die digitalen Medien schmackhaft zu machen, ihnen deren Verwendung zu erleichtern und sie dabei zu unterstützen, diese zur Förderung eines gesünderen Lebensstils einzusetzen.</p>
          <div>
            Das Projekt stützt sich auf drei Säulen:
            <ul class="list-disc ml-4">
              <li>Schulung und Mentoring</li>
              <li>die Gesundheits-App STUPSI</li>
              <li>Vernetzung und Gesundheitsvorträge</li>
            </ul>
          </div>
          <div>
            <ol class="list-decimal ml-4">
              <li>Basisschulungen für Smartphone und Tablet, ehrenamtliche HandybegleiterInnen und ein spezielles Programm zur Ersteinrichtung von Geräten ermächtigen digitale Neulinge zur sicheren Verwendung von Apps, Internet oder Videotelefonie.</li>
              <li>Die Gesundheits-App STUPSI wurde mit der älteren Bevölkerung entwickelt. Sie ist gratis, benutzerfreundlich und unkompliziert. Sie soll zu einem gesundheitsbewussten Verhalten anstupsen (Nudging).</li>
              <li>
                Zusammenkommen im realen Leben spielt eine wichtige Rolle: Bei Smart-Cafés, bei
                <a
                  target="_blank"
                  href="http://www.waldviertler-kernland.at/cms/mahlzeit/"
                >MahlZeit-Mittagstischen</a> mit Gesundheitsvorträgen oder zu einer gemeinsamen Aktivität.
              </li>
            </ol>
          </div>
          <p>Auch die App geht auf die drei Bereiche körperliche Gesundheit, geistige Fitness und soziale Teilhabe ein. Auf diese Weise soll die Gesundheitskompetenz der älteren Bevölkerung gesteigert werden, damit die Menschen so lange wie möglich fit und selbstbestimmt in ihrer gewohnten Umgebung leben können.</p>
          <p>
            Detaillierte Infos zu diesem und weiteren Projekten finden Sie unter
            <a
              target="_blank"
              href="https://www.waldviertler-kernland.at"
            >www.waldviertler-kernland.at</a>
          </p>
          <p>Projektverantwortliche:</p>
          <ul class="list-disc ml-4">
            <li>Verein Waldviertler Kernland (Konzeption, Projektleitung, Umsetzung)</li>
            <li>Donau Universität Krems (Design und Entwicklung der STUPSI App)</li>
            <li>Treffpunkt Bibliothek (Schulungen, Ehrenamtlichen-Intervision)</li>
            <li>NÖ.Regional (Controlling, Dokumentation)</li>
          </ul>
          <div class="w-full grid grid-cols-fit-200 items-center gap-8 my-8">
            <partner-logo
              url="https://www.waldviertler-kernland.at"
              img="/images/logos/Logo frei_Text seitlich_web.jpg"
              alt="Waldviertler Kernland"
            />
            <partner-logo
              img="/images/logos/1200px-Donau_Universität_Krems.svg.png"
              alt="DUK"
              url="http://donau-uni.ac.at/ags"
            />
            <partner-logo
              img="/images/logos/NÖ Regional.jpg"
              alt="NÖ Regional"
              url="https://www.noeregional.at/"
            />
            <partner-logo
              img="/images/logos/Treffpunkt-Bibliothek_Logo_final_CMYK.jpg"
              alt="Treffpunkt Bibliothek"
              url="https://www.treffpunkt-bibliothek.at/"
            />
          </div>
          <div>
            <p>Gefördert vom Fonds Gesundes Österreich im Rahmen der Initiative „Auf gesunde Nachbarschaft!“ und dem Land Niederösterreich.</p>
            <div class="w-full grid grid-cols-fit-200 items-center gap-8 my-8">
              <partner-logo
                img="/images/logos/Logo_FGÖ_218x56_alpha.png"
                alt="Fond Gesundes Österreich"
                url="https://fgoe.org/"
              />
              <partner-logo
                img="/images/logos/goeg_logo_305x58_0.png"
                alt="Gesundheit Österreich"
                url="https://goeg.at/"
              />
              <partner-logo
                img="/images/logos/BMSGPK_Logo_srgb.png"
                alt="Bundesministerium Soziales, Gesundheit, Pflege, Konsumentenschutz"
                url="https://www.sozialministerium.at/"
              />
              <partner-logo
                img="/images/logos/Logo_AGN.jpg"
                alt="Auf gesunde Nachbarschaft"
                url="http://gesunde-nachbarschaft.at/"
              />
            </div>
          </div>
        </div>
      </info-section>
      <info-section title="Impressum">
        <div class="stack">
          <div>
            <ul>
              <li>Medieninhaber: Kleinregion Waldviertler Kernland</li>
              <li>Herausgeber: ARGE – Digital, gesund Altern</li>
            </ul>
          </div>

          <div>
            <ul>
              <li>Projektleitung: Doris Maurer, MA, MA</li>
              <li>Unterer Mark 10</li>
              <li>3631 Ottenschlag</li>
              <li>Telefon: +43 2872 200 79 20</li>
              <li>
                E-Mail:
                <a
                  href="mailto:office@waldviertler-kernland.at"
                >office@waldviertler-kernland.at</a>
              </li>
            </ul>
          </div>
          <p>
            Kontakt
            <br />Wenn Sie Informationen und Auskünfte benötigen oder eine Anregung haben, sind wir gerne für Sie da. Rufen Sie uns unter +43 2872 200 79 20 an, oder schreiben Sie uns eine E-Mail.
            Fotonachweis: ARGE – Digital, gesund Altern
          </p>
        </div>
      </info-section>
      <info-section title="Datenschutz">
        <p
          class="mb-2"
        >Der Schutz Ihrer persönlichen Daten ist uns ein besonderes Anliegen. Wir verarbeiten Ihre Daten daher ausschließlich auf Grundlage der gesetzlichen Bestimmungen (DSGVO, TKG 2003). In diesen Datenschutzinformationen informieren wir Sie über die wichtigsten Aspekte der Datenverarbeitung im Rahmen unserer Website.</p>
        <info-section
          level="2"
          title="Kontakt mit uns"
        >Wenn Sie per E‑Mail Kontakt mit uns aufnehmen, werden Ihre angegebenen Daten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen sechs Monate bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.</info-section>
        <info-section level="2" title="Google Web Fonts">
          <div class="stack">
            <p>Diese Seite nutzt zur einheitlichen Darstellung von Schriftarten so genannte Web Fonts, die von Google bereitgestellt werden. Beim Aufruf einer Seite lädt Ihr Browser die benötigten Web Fonts in Ihren Browsercache, um Texte und Schriftarten korrekt anzuzeigen.</p>
            <p>Zu diesem Zweck muss der von Ihnen verwendete Browser Verbindung zu den Servern von Google aufnehmen. Hierdurch erlangt Google Kenntnis darüber, dass über Ihre IP-Adresse unsere Website aufgerufen wurde. Die Nutzung von Google Web Fonts erfolgt im Interesse einer einheitlichen und ansprechenden Darstellung unserer Online-Angebote. Dies stellt ein berechtigtes Interesse im Sinne von Art. 6 Abs. 1 lit. f DSGVO dar.</p>
            <p>Wenn Ihr Browser Web Fonts nicht unterstützt, wird eine Standardschrift von Ihrem Computer genutzt.</p>
            <p>
              Weitere Informationen zu Google Web Fonts finden Sie unter
              <a
                href="https://developers.google.com/fonts/faq"
              >https://developers.google.com/fonts/faq</a> und in der Datenschutzerklärung von Google:
              <a
                href="https://www.google.com/policies/privacy/"
              >https://www.google.com/policies/privacy/</a>.
            </p>
          </div>
        </info-section>
        <info-section
          level="2"
          title="Ihre Rechte"
        >Ihnen stehen grundsätzlich die Rechte auf Auskunft, Berichtigung, Löschung, Einschränkung, Datenübertragbarkeit, Widerruf und Widerspruch zu. Wenn Sie glauben, dass die Verarbeitung Ihrer Daten gegen das Datenschutzrecht verstößt oder Ihre datenschutzrechtlichen Ansprüche sonst in einer Weise verletzt worden sind, können Sie sich bei der Aufsichtsbehörde beschweren. In Österreich ist dies die Datenschutzbehörde.</info-section>
      </info-section>
    </div>
  </div>
</template>

<script>
const InfoSection = require("@/modules/infos/components/InfoSection.vue")
  .default;
const PartnerLogo = require("@/modules/infos/components/PartnerLogo.vue")
  .default;

export default {
  name: "InfoSite",
  mixins: [],
  data: () => ({
    routes: []
  }),
  components: {
    InfoSection,
    PartnerLogo
  },
  computed: {
    routeMeta() {
      return this.$route.meta;
    }
  },
  methods: {},
  created() {
    this.$store.dispatch("header/reset");
  }
};
</script>

<style scoped>
a {
  @apply text-primary-700 transition-colors duration-200;
}

a:hover {
  @apply text-primary-600;
}
</style>
